export const parseNumber = value => {
  const number = Number(value);
  return Number.isNaN(number) ? null : number;
};